import PageLabel from "../../../components/common/PageLabel/PageLabel";
import { useSelector } from "react-redux";
import useUsers from "../../../hooks/users/useUser";
import React, { useEffect, useState } from "react";
import { supprimerFileMission } from "../../../data/file";
import { cleanAndNormalizeName } from "../../../components/utilities/Utilities";
import { DOWNLOAD_FILE_CLIENT } from "../../../api/apiRoutes";
import {
  Button,
  Col,
  Divider,
  Input,
  message,
  notification,
  Popconfirm,
  Popover,
  Select,
  Space,
  Table,
  Tooltip,
} from "antd";
import swal from "sweetalert";
import TableTitle from "../../../components/common/TableTitle";
import {
  FormContainer,
  TagItem,
} from "../../../components/common/common.components";
import { getIconForFileType } from "../../../components/layout/menu/CustomMenu";
import { ClockCircleOutlined, UserOutlined } from "@ant-design/icons";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCloudUpload,
  faDownload,
  faExclamationCircle,
  faFileEdit,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { appTheme } from "../../../config/theme";
import SearchRow from "../../../components/common/SearchRow";
import FormLabel from "../../../components/common/Form/FormLabel";
import FileUploaderModeleLN from "../../../components/client/outils/upload/FileUploaderModeleLN";
import {
  getClientBogDetails,
  getListeModeLM,
  supprimerFileModeleLM,
} from "../../../data/bogClient";
import FileUpdateUploaderModeleLN from "../../../components/client/outils/upload/FileUpdateUploaderModeleLN";

const ModeleLN = () => {
  const user = useSelector((state) => state.user);
  const users = useUsers();
  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [clientBog, setClientBog] = useState(null);
  const [filtersItems, setFiltersItems] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [paramsRecherche, setParamsRecherche] = useState({
    infoFile: "",
    user_id: "",
  });
  const [isModalEditOpen, setIsModalEditOpen] = useState(false);
  const [currentData, setCurrentData] = useState({});

  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 20,
    },
  });

  const fetchDocumentsClient = async (client_bog) => {
    setLoading(true);
    getListeModeLM(client_bog).then((res) => {
      setFiles(res.result);
      setFiltersItems(res.result);
      setLoading(false);
    });
  };

  const fetchClientBog = async (client_id) => {
    setLoading(true);
    getClientBogDetails(client_id).then((res) => {
      setClientBog(res.result);
      setLoading(false);
    });
  };

  useEffect(() => {
    if (user) {
      const clientBogName = cleanAndNormalizeName(user.nom_cabinet);
      fetchDocumentsClient(clientBogName);
    }
  }, [user]);

  useEffect(() => {
    if (user) {
      fetchClientBog(user.client_id);
    }
  }, [user]);

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      ...sorter,
    });

    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setFiles([]);
    }
  };

  const handleModalOpen = () => {
    setIsModalOpen((prevState) => !prevState);
  };

  const handleEditModalOpen = (record) => {
    setCurrentData(record);
    setIsModalEditOpen((prevState) => !prevState);
  };

  const downloadDocumentsClient = async (
    client_bog,
    fichier,
    libelle,
    extension
  ) => {
    try {
      const clientBogName = cleanAndNormalizeName(client_bog);
      const fileUrl = `${DOWNLOAD_FILE_CLIENT}/${clientBogName}/MODELES/LETTRE-MISSION/${encodeURIComponent(
        fichier
      )}`;
      const response = await fetch(fileUrl, { method: "HEAD" });
      if (!response.ok) {
        if (response.status === 404) {
          throw new Error("Fichier introuvable");
        } else if (response.status === 403) {
          throw new Error("Accès interdit");
        } else {
          throw new Error(`Erreur serveur (${response.status})`);
        }
      }
      // Créer un lien temporaire
      const link = document.createElement("a");
      link.href = fileUrl;
      link.setAttribute("download", `${libelle}.${extension}`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Erreur lors du téléchargement :", error);
      message.error(error.message);
    }
  };

  const handleDeleteModeleLM = (file_id) => {
    setLoading(true);
    const data = {
      file_id,
    };
    supprimerFileModeleLM(data)
      .then(async (res) => {
        const { status, message } = res;
        if (status === "success") {
          setLoading(false);
          const clientBogName = cleanAndNormalizeName(user.nom_cabinet);
          fetchDocumentsClient(clientBogName);
          await swal(`Opération effectuée avec succès`, "", "success");
        } else {
          await swal(message, "", "error");
          setLoading(false);
        }
      })
      .catch((err) => {
        notification.error({
          description: err,
        });
      });
  };

  const columns = [
    {
      title: () => <TableTitle>#</TableTitle>,
      render: (_, record, index) => <>{index + 1}</>,
      width: 40,
    },
    {
      title: () => <TableTitle>Reference</TableTitle>,
      dataIndex: "reference",
      width: 100,
      render: (_, record) => <TagItem>{record.reference}</TagItem>,
    },
    {
      title: () => <TableTitle>Document</TableTitle>,
      dataIndex: "libelle",
      width: 300,
      render: (_, record) => (
        <div className="d-flex align-items-center">
          <span className="svg-icon svg-icon-2x svg-icon-primary me-4">
            {getIconForFileType(record.extension || record.libelle)}
          </span>
          <div
            style={{
              fontFamily: "Oswald, sans-serif",
              fontSize: "12px",
              fontWeight: "700",
            }}
          >
            {record.libelle}
          </div>
        </div>
      ),
    },
    {
      title: () => <TableTitle>Taille (KO)</TableTitle>,
      width: 100,
      dataIndex: "size",
      render: (_, record) => (
        <TagItem>{(record.size / 1024).toFixed(2)}</TagItem>
      ),
    },
    {
      title: () => <TableTitle>Dernière modif.</TableTitle>,
      dataIndex: "modif",
      width: 150,
      render: (_, record) => (
        <div className="d-flex flex-column align-center">
          <span
            className="chart-orange display-block f-size-12 pe-5"
            style={{ fontWeight: 600, fontSize: "11px" }}
          >
            <UserOutlined style={{ fontSize: "15px" }} />{" "}
            {record.Lea_User?.nom_user + " " + record.Lea_User?.prenom_user}
          </span>
          <span
            className="chart-blue display-block f-size-12"
            style={{ fontWeight: 600 }}
          >
            <ClockCircleOutlined style={{ fontSize: "12px" }} />{" "}
            {moment(record.updatedAt).format("DD/MM/YYYY à HH:mm")}
          </span>
        </div>
      ),
    },
    {
      title: () => <TableTitle>Dossier client</TableTitle>,
      dataIndex: "dossiers",
      width: 150,
      render: () => (
        <div className="d-flex flex-column">
          <span style={{ color: "#000", fontWeight: "bold", fontSize: "12px" }}>
            {clientBog?.nom_cabinet || ""}
          </span>
          {/*<span className='text-gray-800 fw-bold text-hover-primary mb-1' style={{fontSize: '12px'}}>*/}
          {/*    {mission.mission} <span className="ms-3">{mission.annee && <TagItem color={appTheme.colors.primary}>{mission.annee}</TagItem>}</span>*/}
          {/*</span>*/}
        </div>
      ),
    },
    {
      title: () => <TableTitle>Notes</TableTitle>,
      dataIndex: "description",
      width: 70,
      render: (_, record) => (
        <>
          {record.description && (
            <Popover
              placement="top"
              title="Notes"
              content={
                <>
                  <Divider />
                  <span
                    style={{
                      fontFamily: "Oswald, sans-serif",
                      fontSize: "13px",
                    }}
                  >
                    {record.description}
                  </span>
                </>
              }
            >
              <Button
                icon={<FontAwesomeIcon icon={faExclamationCircle} />}
                color={""}
              />
            </Popover>
          )}
        </>
      ),
    },
    {
      title: () => <TableTitle>Action</TableTitle>,
      dataIndex: "action",
      width: 70,
      render: (_, record) => (
        <Space>
          <Tooltip
            color={appTheme.colors.primary}
            title="Téléchager le fichier"
          >
            <Button
              shape="circle"
              size={"middle"}
              style={{ backgroundColor: appTheme.colors.primary }}
              onClick={() =>
                downloadDocumentsClient(
                  user.nom_cabinet,
                  record.fichier,
                  record.libelle,
                  record.extension
                )
              }
              icon={<FontAwesomeIcon icon={faDownload} color={"white"} />}
            />
          </Tooltip>
          {
            <>
              <Tooltip color="blue" title="Modifier les infos du fichier">
                <Button
                  shape="circle"
                  size={"middle"}
                  style={{ backgroundColor: "blue" }}
                  onClick={() => handleEditModalOpen(record)}
                  icon={<FontAwesomeIcon icon={faFileEdit} color={"white"} />}
                />
              </Tooltip>
              {/*  */}

              {[
                "Admin",
                "Manager",
                "Chef de Mission",
                "Assistant Senior",
                "Associé",
              ].includes(user.libelleProfil) && (
                <Tooltip title="Supprimer ce fichier">
                  <Popconfirm
                    title="Confirmer la suppression de ce fichier"
                    description="Voulez-vous supprimer ce fichier?"
                    onConfirm={() => handleDeleteModeleLM(record.id)}
                  >
                    <Button
                      shape="circle"
                      size={"middle"}
                      style={{ backgroundColor: "red" }}
                      icon={<FontAwesomeIcon icon={faTrash} color={"white"} />}
                    />
                  </Popconfirm>
                </Tooltip>
              )}
            </>
          }
        </Space>
      ),
    },
  ];

  const handleSearchss = () => {
    setLoading(true);
    setTimeout(() => {
      const filteredClients = files.filter((file) => {
        const referenceMatch =
          !paramsRecherche.reference ||
          file.reference
            ?.toLowerCase()
            .includes(paramsRecherche.reference.toLowerCase());

        const infoFileMatch =
          file.libelle
            ?.toLowerCase()
            .includes(paramsRecherche.infoFile.toLowerCase()) ||
          file.description
            ?.toLowerCase()
            .includes(paramsRecherche.infoFile.toLowerCase());

        const userMatch =
          paramsRecherche.user_id === "" ||
          file.Lea_User?.id === paramsRecherche.user_id;

        return referenceMatch && infoFileMatch && userMatch;
      });

      setFiltersItems(filteredClients);
      setLoading(false);
    }, 2000);
  };

  const handleSearch = () => {
    setLoading(true);

    setTimeout(() => {
      const filteredClients = files.filter((file) => {
        const referenceMatch =
          !paramsRecherche.reference ||
          file.reference
            ?.toLowerCase()
            .includes(paramsRecherche?.reference.toLowerCase());
        const libelleMatch = file.libelle
          ?.toLowerCase()
          .includes(paramsRecherche?.infoFile.toLowerCase());
        const descriptionMatch = file.description
          ?.toLowerCase()
          .includes(paramsRecherche?.infoFile.toLowerCase());
        const userMatch =
          paramsRecherche.user_id === "" ||
          file.Lea_User?.id === paramsRecherche.user_id;

        return (
          referenceMatch && (descriptionMatch || libelleMatch) && userMatch
        );
      });

      setFiltersItems(filteredClients);
      setLoading(false);
    }, 2000);
  };

  const handleReset = () => {
    setLoading(true);
    setParamsRecherche({
      reference: "",
      infoFile: "",
      user_id: "",
    });
    setFiltersItems(files);
    setLoading(false);
  };

  return (
    <>
      <PageLabel label="Modèle Lettre de Mission" />
      <SearchRow
        handleSearch={handleSearch}
        handleReset={handleReset}
        loading={loading}
      >
        <Col
          xs={{ span: 24 }}
          md={{ span: 12 }}
          lg={{ span: 8 }}
          xl={{ span: 8 }}
        >
          <FormLabel label="Référence" />
          <Input
            style={{ width: "100%" }}
            size="large"
            placeholder="Référence"
            value={paramsRecherche.reference || null}
            onChange={(e) =>
              setParamsRecherche({
                ...paramsRecherche,
                reference: e.target.value,
              })
            }
          />
        </Col>
        <Col
          xs={{ span: 24 }}
          md={{ span: 12 }}
          lg={{ span: 8 }}
          xl={{ span: 8 }}
        >
          <FormLabel label="Fichier" />
          <Input
            style={{ width: "100%" }}
            size="large"
            placeholder="Libellé ou description"
            value={paramsRecherche.infoFile || null}
            onChange={(e) =>
              setParamsRecherche({
                ...paramsRecherche,
                infoFile: e.target.value,
              })
            }
          />
        </Col>
        <Col
          xs={{ span: 24 }}
          md={{ span: 12 }}
          lg={{ span: 8 }}
          xl={{ span: 8 }}
        >
          <FormLabel label="Utilisateurs" />
          <Select
            placeholder="Utilisateur"
            size="large"
            style={{ width: "100%" }}
            value={paramsRecherche.user_id || null}
            onSelect={(value) =>
              setParamsRecherche({ ...paramsRecherche, user_id: value })
            }
            options={
              users &&
              users.users.map((user) => ({
                value: user.id,
                label: `${
                  user.initial || ""
                } - ${user.nom_user.toUpperCase()} ${
                  user.prenom_user ? user.prenom_user.toUpperCase() : ""
                }`,
              }))
            }
          />
        </Col>
      </SearchRow>
      <FormContainer>
        <div className="w-100">
          {
            <div className="d-flex justify-content-end align-center my-2 me-5">
              <Tooltip
                color={appTheme.colors.primary}
                title="Importer un fichier pour l'exercice"
              >
                <Button
                  size={"middle"}
                  style={{ backgroundColor: appTheme.colors.primary }}
                  onClick={handleModalOpen}
                  icon={
                    <FontAwesomeIcon icon={faCloudUpload} color={"white"} />
                  }
                >
                  Importer
                </Button>
              </Tooltip>
            </div>
          }
          <div className="py-4">
            <div className="table-responsive">
              <Table
                columns={columns}
                rowKey={(record) => record.id}
                dataSource={filtersItems}
                pagination={tableParams.pagination}
                loading={loading}
                onChange={handleTableChange}
                rowSelection
                size={"small"}
              />
            </div>
          </div>
        </div>
      </FormContainer>
      {isModalOpen && (
        <FileUploaderModeleLN
          handleVisibility={handleModalOpen}
          client={clientBog}
          visible={isModalOpen}
          chargement={loading}
          fetchData={fetchDocumentsClient}
          user={user}
        />
      )}

      {isModalEditOpen && (
        <FileUpdateUploaderModeleLN
          handleVisibility={handleEditModalOpen}
          data={currentData}
          client={clientBog}
          visible={isModalEditOpen}
          chargement={loading}
          fetchData={fetchDocumentsClient}
        />
      )}

      {/* {isModalEditOpen && (
        <FileUpdateUploaderModeleLN
          handleVisibility={handleEditModalOpen}
          data={currentData}
          client={clientBog}
          visible={isModalEditOpen}
          chargement={loading}
          fetchData={fetchDocumentsClient}
        />
      )} */}
    </>
  );
};

export default ModeleLN;
